import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

const { REACT_APP_BACKEND_URL } = process.env;

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [authState, setAuthState] = useState({
        token: localStorage.getItem('token'),
        isAuthenticated: null,
        loading: true,
        user: JSON.parse(localStorage.getItem('user')) || null,
    });

    useEffect(() => {
        const checkAuthStatus = async () => {
            if (authState.token) {
                try {
                    const res = await axios.get(`${REACT_APP_BACKEND_URL}/api/auth/status`, {
                        headers: {
                            'x-auth-token': authState.token,
                        },
                    });
                    console.log('Auth status response:', res.data);
                    setAuthState(prevState => ({
                        ...prevState,
                        isAuthenticated: res.data.isAuthenticated,
                        loading: false,
                        user: res.data.user,
                    }));
                    localStorage.setItem('user', JSON.stringify(res.data.user));
                } catch (err) {
                    console.error('Auth status error:', err);
                    setAuthState(prevState => ({
                        ...prevState,
                        isAuthenticated: false,
                        loading: false,
                        user: null,
                    }));
                    localStorage.removeItem('user');
                }
            } else {
                setAuthState(prevState => ({
                    ...prevState,
                    isAuthenticated: false,
                    loading: false,
                    user: null,
                }));
                localStorage.removeItem('user');
            }
        };

        checkAuthStatus();
    }, [authState.token]);

    console.log('Current auth state:', authState);

    const login = (token, user) => {
        console.log('Login called with token and user:', { token, user });
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        setAuthState({
            token,
            isAuthenticated: true,
            loading: false,
            user,
        });
    };

    const logout = () => {
        console.log('Logout called');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setAuthState({
            token: null,
            isAuthenticated: false,
            loading: false,
            user: null,
        });
    };

    return (
        <AuthContext.Provider value={{ authState, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthProvider };